import { render, staticRenderFns } from "./Adjustment.vue?vue&type=template&id=681e26b8&scoped=true&"
import script from "./Adjustment.vue?vue&type=script&lang=js&"
export * from "./Adjustment.vue?vue&type=script&lang=js&"
import style0 from "./Adjustment.vue?vue&type=style&index=0&id=681e26b8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681e26b8",
  null
  
)

export default component.exports